import { obterMarcaEquipamentoAsync } from "../../services/marcaEquipamentoService";

const atualizarMarcaEquipamentos = async ({ commit }) => {
    const marcaEquipamentos = await obterMarcaEquipamentoAsync();
    commit('atualizarMarcaEquipamentos', marcaEquipamentos);
}

const atualizarMarcaEquipamento = ({ commit }, marcaEquipamento) => {
    commit('atualizarMarcaEquipamento', marcaEquipamento);
}

export default {
    atualizarMarcaEquipamentos,
    atualizarMarcaEquipamento
}